import moment from 'moment';
import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

  
export function getListarAreas(){

    const config = {
        headers: {
          idUsuario: IDUSUARIO,
      }    
    };

   return  customAxios.get(`${FDV_URL}/ficha-venta/mantenimiento/listarAreas`,config);    
}
  




export function getListarCertificado(buscar=''){

  const config = {
      headers: {
        buscar:buscar,
        idUsuario: IDUSUARIO,
    }
   
  };

 return  customAxios.get(`${FDV_URL}/ficha-venta/mantenimiento/listarCertificados`,config);    
}

export function createCertificado(values,cod_chek) {
 

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    cod_area_vta: values.cod_area_vta,
    cod_chek: cod_chek,  
    ind_default: values.ind_default,
    ind_inactivo: values.ind_inactivo,
  };

  return customAxios.post(`${FDV_URL}/ficha-venta/mantenimiento/registrarArea`, data, config);
}


export function getListaAreaVenta(codCheck='') {


  const config = { 
    params:{
      cod_chek:codCheck,
    }, 
    headers: {
      idUsuario: IDUSUARIO, 
    },
  };

  return customAxios.get(`${FDV_URL}/ficha-venta/mantenimiento/listarAreaVenta`, config);
}

export function createArea(cod_chek='',valueChek='',des_chek='') {
 

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    cod_chek: cod_chek,  
    ind_inactivo: valueChek === true? 'N':'S',
    des_chek: des_chek,
  };

  return customAxios.post(`${FDV_URL}/ficha-venta/mantenimiento/registrarChek`, data, config);
}


// WEBPACK FOOTER //
// ./src/utils/mantenimientoFichaVenta.js